import React, { FunctionComponent } from 'react';
import i18next from 'i18next';

import { history } from 'helpers/history';

import Button from 'components/commons/Button';

import { ButtonsContainer } from './styles';

import './i18n';

interface IProceduresButtonsProps {
  isVerified: boolean;
}

const ProceduresButtons: FunctionComponent<IProceduresButtonsProps> = ({ isVerified }) => (
  <ButtonsContainer>
    <Button
      disabled={!isVerified}
      onClick={() => history.push('/public/procedures/forms/divorces/create')}
    >
      {i18next.t<string>('PUBLIC_PROCEDURES_BUTTONS:DIVORCE')}
    </Button>
    <Button
      disabled={!isVerified}
      onClick={() => history.push('/public/procedures/forms/jewishness/create')}
    >
      {i18next.t<string>('PUBLIC_PROCEDURES_BUTTONS:JEWISHNESS')}
    </Button>
    <Button
      disabled={!isVerified}
      onClick={() => history.push('/public/procedures/forms/deaths/create')}
    >
      {i18next.t<string>('PUBLIC_PROCEDURES_BUTTONS:DEATH')}
    </Button>
    <Button
      disabled={!isVerified}
      onClick={() => history.push('/public/procedures/forms/reservations/create')}
    >
      {i18next.t<string>('PUBLIC_PROCEDURES_BUTTONS:RESERVATION')}
    </Button>
    <Button
      disabled={!isVerified}
      onClick={() => history.push('/public/procedures/forms/marriages/create')}
    >
      {i18next.t<string>('PUBLIC_PROCEDURES_BUTTONS:MARRIAGE')}
    </Button>
    <Button
      disabled={!isVerified}
      onClick={() => history.push('/public/procedures/forms/matzeva/create')}
    >
      {i18next.t<string>('PUBLIC_PROCEDURES_BUTTONS:MATZEVA')}
    </Button>
  </ButtonsContainer>
);

export default ProceduresButtons;
